import React, { useEffect, useRef, useState } from 'react';
import { loginWithAuth0, isAuth0Configured } from '../../Services/AuthService';

const Login = props => {
    const [message, setMessage] = useState("");
    const hasStartedRedirect = useRef(false);
    const searchParams = new URLSearchParams(window.location.search);
    const isAuth0Callback = searchParams.has('code') || searchParams.has('state') || searchParams.has('error');

    useEffect(() => {
        if (isAuth0Callback) {
            return;
        }

        if (hasStartedRedirect.current) {
            return;
        }

        hasStartedRedirect.current = true;

        const startAuth0Login = async () => {
            if (!isAuth0Configured()) {
                setMessage('Auth0 is not configured for this environment.');
                return;
            }

            try {
                await loginWithAuth0({
                    authorizationParams: {
                        redirect_uri: window.location.origin,
                        screen_hint: 'login'
                    }
                });
            } catch (error) {
                setMessage(error?.message || 'Unable to start Auth0 login.');
            }
        };

        startAuth0Login();
    }, [isAuth0Callback]);

    return (
        <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight: '70vh' }}>
            <div className="text-center">
                {message && <p className="error mb-0">{message}</p>}
            </div>
        </div>
    );
};

export default Login;